import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-info-header',
    templateUrl: './info-header.component.html',
    styleUrls: ['./info-header.component.scss'],
    standalone: false
})
export class InfoHeaderComponent implements OnInit {

	@Input() public header: string;
	
	@Input() public hasButton: boolean;
	@Output() public onButtonClicked: EventEmitter<any> = new EventEmitter();
	@Input() public iconClass: string = "fa-solid fa-link";
	@Input() public iconTitle: string = "";
	
	public onButtonClick(event) {
		this.onButtonClicked.emit(event);
	}

	@Output() public toggleViewValueChange: EventEmitter<boolean> = new EventEmitter<boolean>();
	private _toggleViewValue: boolean;
	public get toggleViewValue(): boolean {
		return this._toggleViewValue;
	}
	@Input()
	public set toggleViewValue(value: boolean) {
		this._toggleViewValue = value;

		this.toggleViewValueChange.emit(this._toggleViewValue);
	}

	@Input() public hasToggleViewButton: boolean;
	@Output() public onToggleViewButtonClicked: EventEmitter<boolean> = new EventEmitter<boolean>();	

	public toggleView() {
		this.toggleViewValue = !this.toggleViewValue;

		this.onToggleViewButtonClicked.emit(this.toggleViewValue);
	}

  constructor() { }

  ngOnInit() {
  }
}
